import React, { useState } from 'react';
import { Button, Drawer, Input, Table } from 'antd';
import { IoMdAdd } from 'react-icons/io';
import './ApiKeys.css';

const SideClose = '/assets/ModalClose.svg';
const columns = [
    {
        title: 'SR',
        dataIndex: 'sr',
        key: 'sr',
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: 'Token',
        dataIndex: 'token',
        key: 'token',
    },
    {
        title: 'Created',
        dataIndex: 'created',
        key: 'created',
    },
    {
        title: 'Last Used',
        dataIndex: 'lastUsed',
        key: 'lastUsed',
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
    },
];

const ApiKeys = () => {
    const [isStandardOpen, setIsStandardOpen] = useState(false);
    const [isRestrictedOpen, setIsRestrictedOpen] = useState(false);

    const data = [
        {
            key: '1',
            sr: 1,
            name: 'John Doe 1',
            type: 'Admin',
            token: 'abc123',
            created: '2023-01-01',
            lastUsed: '2023-01-15',
            status: 'Active',
        },
        {
            key: '2',
            sr: 2,
            name: 'Jane Smith 2',
            type: 'User',
            token: 'xyz456',
            created: '2023-02-01',
            lastUsed: '2023-02-15',
            status: 'Inactive',
        },
        {
            key: '3',
            sr: 1,
            name: 'John Doe 1',
            type: 'Admin',
            token: 'abc123',
            created: '2023-01-01',
            lastUsed: '2023-01-15',
            status: 'Active',
        },
        {
            key: '4',
            sr: 2,
            name: 'Jane Smith 2',
            type: 'User',
            token: 'xyz456',
            created: '2023-02-01',
            lastUsed: '2023-02-15',
            status: 'Inactive',
        },
        {
            key: '5',
            sr: 1,
            name: 'John Doe 1',
            type: 'Admin',
            token: 'abc123',
            created: '2023-01-01',
            lastUsed: '2023-01-15',
            status: 'Active',
        },
        {
            key: '6',
            sr: 2,
            name: 'Jane Smith 2',
            type: 'User',
            token: 'xyz456',
            created: '2023-02-01',
            lastUsed: '2023-02-15',
            status: 'Inactive',
        },
    ];

    const RestrictedOverlay = () => {
        setIsRestrictedOpen(!isRestrictedOpen);
    };

    const StandardOverlay = () => {
        setIsStandardOpen(!isStandardOpen);
    };

    return (
        <div>
            <div className='apikey-container'>
                <div className='apikey-main'>
                    <div>
                        <h3>Standard API Keys</h3>
                        <h5>
                            Standard keys provide you with 1 API to access all
                            of your quick actions
                        </h5>
                    </div>
                    <div>
                        <Button className='main-api' onClick={StandardOverlay}>
                            <IoMdAdd />
                            Create New Standard API
                        </Button>
                    </div>
                </div>
                <Table
                    columns={columns}
                    dataSource={data}
                    bordered
                    size='middle'
                    pagination={{
                        pageSize: 4,
                    }}
                    className='mytable'
                />
            </div>

            <div className='apikey-container'>
                <div className='apikey-main'>
                    <div>
                        <h3>Restricted API Keys</h3>
                        <h5>
                            Restricted API keys allow you the flexibility to
                            create an API key for a specific QuickAction
                        </h5>
                    </div>
                    <div>
                        <Button
                            className='main-api'
                            onClick={RestrictedOverlay}>
                            <IoMdAdd />
                            Create New Restricted API
                        </Button>
                    </div>
                </div>
                <Table
                    columns={columns}
                    dataSource={data}
                    bordered
                    size='middle'
                    pagination={{
                        pageSize: 4,
                    }}
                    className='mytable'
                />
            </div>

            <Drawer
                placement='right'
                closable={false}
                onClose={StandardOverlay}
                open={isStandardOpen}
                key='right'
                width={'40%'}>
                <img
                    src={SideClose}
                    alt=''
                    onClick={StandardOverlay}
                    style={{ float: 'right', cursor: 'pointer' }}
                />
                <div className='side-modal-div'>
                    <h3>Generate new standard API</h3>
                    <p>Create new standard API for all QuickActions</p>
                </div>
                <div className='api-key-input'>
                    <div className='api-key-1'>
                        <label>API Name</label>
                        <Input placeholder='Basic usage' />
                    </div>
                    <div className='api-key-3'>
                        <Button className='api-save'>save</Button>
                    </div>
                </div>
            </Drawer>

            <Drawer
                placement='right'
                closable={false}
                onClose={RestrictedOverlay}
                open={isRestrictedOpen}
                key='right'
                width={'40%'}>
                <img
                    src={SideClose}
                    alt=''
                    onClick={RestrictedOverlay}
                    style={{ float: 'right', cursor: 'pointer' }}
                />
                <div className='side-modal-div'>
                    <h3>Generate new standard API</h3>
                    <p>Create new restricted API for specific QuickActions</p>
                </div>
                <div className='api-key-input'>
                    <div className='api-key-1'>
                        <label>API Name</label>
                        <Input placeholder='Basic usage' />
                    </div>
                    <div className='api-key-2'>
                        <label>Select QuickActions</label>
                        <select>
                            <option defaultValue='select'>select</option>
                            <option value='option1'>Option 1</option>
                            <option value='option2'>Option 2</option>
                            <option value='option3'>Option 3</option>
                        </select>
                    </div>
                    <div className='api-key-3'>
                        <Button className='api-save'>save</Button>
                    </div>
                </div>
            </Drawer>
        </div>
    );
};

export default ApiKeys;
